module.exports = __webpack_public_path__ + "static/offer-modal-desktop_c-42c7565b7adc6a43c6afa12bc5ce08dc.webp";